<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <!--        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>-->
        <div>
          <div class="flex flex_gap_10">
            <date-range-picker
              ref="picker"
              :startDate="startDate"
              opens="right"
              :ranges="ranges"
              :locale-data="date_locale"
              v-model="dateRange"
            >
            </date-range-picker>

            <LoadingButton
              title="Показать"
              type="button"
              :loading="loading"
              :color="$constants.SUCCESS_COLOR"
              :onClick="() => getStatistics()"
              className="btn btn-outline-success"
            />
          </div>
          <StatsManagersGroups v-if="activeGroup" :dateRange="dateRange" :editGroup="activeGroup" :allGroups="allGroups"
                               :stats="stats"
                               :schedule="shifts.reduce((acc, s) => {
                                 acc[s.id] = s;
                                 return acc;
                               }, {})"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import api from "@/api";
import DateRangePicker from 'vue2-daterange-picker';
import moment from 'moment';
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import ManagerOrdersStats from "@/views/users/components/ManagerOrdersStats.vue";
import ManagerOrdersStatsDiff from "@/views/users/components/ManagerOrdersStatsDiff.vue";
import EditGroup from "@/views/users/components/EditGroup.vue";
import StatsManagersGroups from "@/views/users/components/StatsManagersGroups.vue";

export default {
  title: 'Группы менеджеров',
  components: {
    StatsManagersGroups,
    EditGroup, ManagerOrdersStatsDiff, ManagerOrdersStats, LoadingButton, DateRangePicker
  },
  data() {
    return {
      loading: false,
      groups: null,
      activeGroup: null,
      showStatistics: false,
      allGroups: [],
      shifts: [],
      stats: null,
      startDate: '',
      dateRange: {
        startDate: moment().startOf('isoWeek'),
        endDate: moment().endOf('isoWeek'),
      },
      ranges: { //default value for ranges object (if you set this to false ranges will no be rendered)
        'Текущая неделя': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
        'Прошлая неделя': [moment().subtract(1, 'isoWeek').startOf('isoWeek'), moment().subtract(1, 'isoWeek').endOf('isoWeek')],
        'Текущий месяц': [moment().startOf('month'), moment().endOf('month')],
        'Прошлый месяц': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
      date_locale: {
        firstDay: 1,
        format: 'DD-MM-YYYY',
        applyLabel: 'Выбрать',
        cancelLabel: 'Отмена',
      },
    }
  },
  computed: {
    $AllProjects() {
      return this.$store.getters['platform/projects'].reduce((acc, p) => {
        acc[p.id] = p;
        return acc;
      }, {})
    },
  },
  created() {
    this.getRecords();
  },
  methods: {
    async getStatistics() {
      this.loading = true;
      this.stats = null;
      this.activeGroup = null;
      const {data} = await api.post('/new/orders/statistics', {
        type: 1,
        dateRange: this.dateRange,
      })
      if (data.success) {
        this.activeGroup = data.group;
        toastr['success']('Начался сбор статистики. Ожидайте', 'Успешно');
      }
      this.loading = false;
      // this.showStatistics = true;
    },
    async getRecords() {
      this.loading = true;
      const {data} = await api.index('/new/users/managers/groups');
      if (data.success) {
        this.allGroups = data.all_groups;
        this.shifts = data.shifts;
        // this.activeGroup = data.activeGroup;
      }
      this.loading = false;
    }
  }
}

</script>
